import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ListSubheader, Stack, Select, FormControl, InputLabel, Button, Box, Grid, Card, CardContent, CardActions, Paper, CircularProgress, Popover, Typography, Divider, MenuItem } from '@mui/material';
import client from '../common/client';
import { getSelectedProject } from '../common/common.js';

const MyListSubheader = (
    props: ListSubheaderProps & { muiSkipListHighlight: boolean },
) => {
    const { muiSkipListHighlight, ...other } = props;
    return <ListSubheader {...other} />;
}
MyListSubheader.muiSkipListHighlight = true;

const IDEHeader = props => {
    const [projectId, setProjectId] = useState('')
    const [projectList, setProjectList] = useState([])
    const [recentProjectList, setRecentProjectList] = useState([])
    
    const navigate = useNavigate()

    useEffect(() => {
        client.request_get('/project').then(list => {
            //console.log('list', list)
            if(!Array.isArray(list))
                return
            
            // localStorage.removeItem('recent_project');
            let recent_project_list = localStorage.getItem('recent_project');
            if(!recent_project_list)
                recent_project_list = []
            else
                recent_project_list = JSON.parse(recent_project_list)

            let new_recent_list = []
            recent_project_list.map(m=>{
                let found = list.find(f=>f.id == m)
                if(found)
                    new_recent_list.push(found)
            })

            setRecentProjectList(new_recent_list)

            setProjectList(list)
            setProjectId(getSelectedProject())
        })
    }, [])

    const handleProjectSelect = (event) => {
        
        let recent_project_list = localStorage.getItem('recent_project');
        if(!recent_project_list)
            recent_project_list = []
        else
            recent_project_list = JSON.parse(recent_project_list)
        
        recent_project_list = recent_project_list.filter(m => m != event.target.value)
        recent_project_list.splice(0, 0, event.target.value)
        if(recent_project_list.length > 5)
            recent_project_list = recent_project_list.slice(0, 5)
        localStorage.setItem('recent_project', JSON.stringify(recent_project_list));

        setProjectId(event.target.value);
        sessionStorage.setItem('devil_project', event.target.value);
        props.onChangeProject(event.target.value)
    }

    const handleAction = (name) => {
        if(name == 'show') {
            navigate(`/project/${projectId}/show`)
        } else if(name == 'edit') {
            navigate(`/project/${projectId}`)
        }
    }

    return (
        <Box sx={{ display: 'flex', alignItems: "center", paddingLeft: '10px', bgcolor: '#eeeeee' }}>
            <Box ml={1} onClick={()=>{navigate('/')}}>DAB</Box>
            <Box ml={1} onClick={()=>{navigate('/')}}>IDE</Box>
            <Box ml={1}>
                <Select
                    value={projectId}
                    onChange={handleProjectSelect}
                    sx={{ m: 1, minWidth: 120, height: '35px' }}
                    displayEmpty
                    inputProps={{ 'aria-label': 'Without label' }}
                >
                    <MyListSubheader>Recent</MyListSubheader>
                    {recentProjectList.map(m => (
                        <MenuItem value={m.id} key={m.id}>
                            <em>{`${m.name}`}</em>
                        </MenuItem>
                    ))}

                    <MyListSubheader>All</MyListSubheader>
                    {projectList.map(m => (
                        <MenuItem value={m.id} key={m.id}>
                            <em>{`${m.name}`}</em>
                        </MenuItem>
                    ))}


                </Select>
            </Box>
            <Stack spacing={1} direction={{ xs: "row" }} sx={{
                width: '100%', height: '50px', alignItems: "center", justifyContent: 'right',
                paddingRight: '10px'
            }}>
                <Box>
                    <Button variant="outlined" size="small" onClick={()=>{handleAction('show')}}>Project Show</Button>
                </Box>
                <Box>
                    <Button variant="outlined" size="small" onClick={()=>{handleAction('edit')}} >Project Edit</Button>
                </Box>
                <Box>
                    <Button variant="outlined" size="small" onClick={()=>{handleAction('')}}>App Distribute</Button>
                </Box>
                <Box>
                    <Button variant="outlined" size="small" onClick={()=>{handleAction('')}}>Backend Distribute</Button>
                </Box>
            </Stack>
            <Divider />
        </Box>
    );
};

export default IDEHeader;
